var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501180097,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4208,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.44h896V512H64z",
    fill: "#FCD115",
    opacity: 0.75,
    "p-id": 4209
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M944 213.44H960V512h-16V213.44zM64 213.44h16V512H64V213.44z",
    fill: "#FCD115",
    "p-id": 4210
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.44h896v16H64z",
    fill: "#FCD115",
    "p-id": 4211
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 512h896v149.312H64z",
    fill: "#013893",
    opacity: 0.75,
    "p-id": 4212
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M944 512H960v149.312h-16V512.064zM64 512h16v149.312H64V512.064z",
    fill: "#013893",
    "p-id": 4213
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 661.248h896v149.312H64z",
    fill: "#CE1025",
    opacity: 0.75,
    "p-id": 4214
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 661.248h16v149.312H64v-149.248z m880 0H960v149.312h-16v-149.248z",
    fill: "#CE1025",
    "p-id": 4215
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 794.56h896v16H64z",
    fill: "#CE1025",
    "p-id": 4216
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo);
export default __webpack_public_path__ + "static/media/co.8000726a.svg";
export { ForwardRef as ReactComponent };